import React, { FunctionComponent } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import VersionNumber from "VersionNumber";
import Separator from "components/common/Separator";
import { hideHeader } from 'Utilities/QueryParamSettings';

interface MainLayoutProps {
	header?: React.ReactNode;
}

export const MainLayout: FunctionComponent<MainLayoutProps> = (props) => {
	if (hideHeader()) {
		return (
			<>
				<div className='centerer'>
					{props.children}
				</div>
				<div className='footer no-print'>
					<p>versionumero: {VersionNumber}</p>
				</div>
			</>
		)
	} else {
		return (
			<React.Fragment>
				<Container>
					<header>
						<Row className='header justify-content-between'>
							<Col className='px-2 px-sm-4 header-logo-container' xs='auto'>
								<img src='/logo.png'
									className="header-logo"
									alt="Kuntoutussäätiö" />
							</Col>
							<Col className='d-flex px-2 px-sm-4 align-self-center justify-content-end no-print'>
								{props.header}
							</Col>
						</Row>
						<Row>
							<Separator className='header-separator' />
						</Row>
					</header>
				</Container>
				{props.children}
				<div className='footer no-print'>
					<p>versionumero: {VersionNumber}</p>
				</div>
			</React.Fragment>
		)
	}

}